<template>
  <class-detail-section class="teacher-section-info" title="Biography">
    <template #actions>
      <button
        v-if="teacherProfile.can_edit"
        class="teacher-section-info__edit-button"
        @click="editBio"
        data-test-id="edit-bio-button"
      >
        <span class="teacher-section-info__edit-icon">
          <font-awesome-icon :icon="['fas', 'edit']" />
        </span>
      </button>
    </template>

    <div class="teacher-skill">
      <div class="teacher-section-info__split-col">
        <div class="teacher-section-info__value" data-test-id="profile-info-extended">
          {{ teacherProfile.profile_info_extended }}
        </div>
      </div>
    </div>
  </class-detail-section>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ClassDetailSection from '@/views/classes/components/ClassDetailSection';
import ModalTeacherProfileInfo from './forms/ModalTeacherProfileInfo';
import constants from './forms/constants';

export default {
  name: 'TeacherBio',

  components: {
    ClassDetailSection,
    FontAwesomeIcon,
  },

  props: {
    teacherProfile: {
      type: Object,
      required: true,
    },
  },

  methods: {
    editBio() {
      this.$modal.show(ModalTeacherProfileInfo, ...constants.modalConfig(this));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';
@import '~styles/components/teacher-management-sections';
</style>
